import { useState } from 'preact/hooks';
import { api } from '../api/client';
import type { IBuyerSelectionHistory } from '../types';

interface Props {
    offerCode: number;
    selectCode: number;
}

export default function BuyerSelectHistoryTooltip({ offerCode, selectCode }: Props) {
    const [data, setData] = useState<IBuyerSelectionHistory[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleOpen = async () => {
        setOpen(true);
        if (data) return;
        setLoading(true);
        try {
            const result = await api.getBuyerSelectHistory(offerCode, selectCode);
            setData(result);
        } catch { setData([]); }
        setLoading(false);
    };

    return (
        <>
            <button className="btn btn-xs btn-ghost text-warning" onClick={handleOpen} title="История изменений">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </button>

            {open && (
                <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center" onClick={() => setOpen(false)}>
                    <div className="bg-base-100 rounded-lg shadow-xl max-w-lg w-full max-h-[60vh] flex flex-col" onClick={e => e.stopPropagation()}>
                        <div className="p-4 border-b border-base-300 flex justify-between items-center">
                            <h3 className="font-semibold text-sm">История изменений</h3>
                            <button className="btn btn-ghost btn-xs" onClick={() => setOpen(false)}>✕</button>
                        </div>
                        <div className="flex-1 overflow-auto p-4">
                            {loading ? (
                                <div className="text-center py-4"><span className="loading loading-spinner loading-sm" /></div>
                            ) : !data || data.length === 0 ? (
                                <div className="text-center py-4 text-base-content/60 text-sm">Нет истории</div>
                            ) : (
                                <table className="table table-xs w-full">
                                    <thead>
                                        <tr><th>Дата</th><th>Кол-во</th><th>ЗЦ</th><th>РЦ</th><th>РРЦ</th></tr>
                                    </thead>
                                    <tbody>
                                        {data.map(h => (
                                            <tr key={h.code}>
                                                <td>{h.dat_hst || h.dat_update || '—'}</td>
                                                <td>{h.quantity}</td>
                                                <td>{h.purchase_price}</td>
                                                <td>{h.selling_price}</td>
                                                <td>{h.recommended_price}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
